class ScxLateralMenu extends HTMLElement {
  constructor() {
    super();

    this.menuClick = this.menuClick.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
    this.resetMenu = this.resetMenu.bind(this);
    this.closeMobile = this.closeMobile.bind(this);
  }

  connectedCallback() {
    const mainMenuButton = this.querySelector("#menu--btn");
    if (mainMenuButton) {
      mainMenuButton.addEventListener("click", this.menuClick);
    }

    const mainMenuMobileButton = document.querySelector("#mobile-menu--btn");
    if (mainMenuMobileButton) {
      mainMenuMobileButton.addEventListener("click", this.menuClick);
    }

    const optionClickButton = this.querySelectorAll(".lvl1--single-option");
    if (optionClickButton) {
      optionClickButton.forEach((elem) => {
        elem.addEventListener("click", this.onOptionClick);
      });
    }

    const levelBackButton = this.querySelector("#lvl2-back");
    if (levelBackButton) {
      levelBackButton.addEventListener("click", this.resetMenu);
    }

    const openLvl1Btn = document.querySelector("#products-main-menu-mobile");
    if (openLvl1Btn) {
      openLvl1Btn.addEventListener("click", this.openLevel1Menu);
    }

    const resetLvl1Btn = document.querySelector("#products-main-menu-mobile-reset");
    if (resetLvl1Btn) {
      resetLvl1Btn.addEventListener("click", this.resetLevel1Menu);
    }

    const mainMenuCloseBtn = document.querySelector("#main-menu--close-btn");
    if (mainMenuCloseBtn) {
      mainMenuCloseBtn.addEventListener("click", this.closeMobile);
    }
  }

  overflowBody(state) {
    document.body.style.overflow = state === true ? "hidden" : "auto";
  }

  getTopFromSelector(selector) {
    const _div = document.querySelector(selector);
    const rect = _div.getBoundingClientRect();
    const distToTop = rect.height + rect.top;
    return distToTop;
  }

  closeMenu() {
    const width = window.innerWidth;
    if (width >= 990) {
      this.changeMenuIcon("burger");
    }

    this.overflowBody(false);

    const mainDiv = document.querySelector(`#main-menu`);
    mainDiv.setAttribute("data-menu-open", "false");
    this.resetMenu();
  }

  openMenu() {
    const width = window.innerWidth;

    this.overflowBody(true);

    const mainDiv = document.querySelector(`#main-menu`);
    const distToTop = this.getTopFromSelector(".lateral--menu");

    const lvl0 = document.querySelector(`.lateral-menu--content-inner-lvl0`);
    const lvl1 = document.querySelector(`.lateral-menu--content-inner-lvl1`);

    if (width >= 990) {
      this.changeMenuIcon("close");
      mainDiv.style.setProperty("--dist-to-top", `${distToTop}px`);
      lvl0.setAttribute("data-show", "false");
      lvl1.setAttribute("data-open", "true");
    } else {
      lvl0.setAttribute("data-show", "true");
      lvl1.setAttribute("data-open", "false");
    }

    mainDiv.setAttribute("data-menu-open", "true");
  }

  resetMenu() {
    const lvl1Div = document.querySelector(`.lateral-menu--content-inner-lvl1`);
    lvl1Div.setAttribute("data-open", true);

    const lvl2Containers = document.querySelectorAll(".lvl2--container");
    lvl2Containers.forEach((elem) => {
      if (attr) {
        elem.setAttribute("data-show", "false");
      }
    });

    const lvl2ContentInner = document.querySelector(".lateral-menu--content-inner-lvl2");
    lvl2ContentInner.setAttribute("data-target", "none");
    lvl2ContentInner.setAttribute("data-open", "false");
  }

  handleOutsideClick(event) {
    const lateralMenu = document.querySelector(".lateral-menu--content");
    if (!lateralMenu.contains(event.target)) {
      this.closeMenu();
    }
  }

  changeMenuIcon(state) {
    const burgerIcon = document.querySelector(".menu--icon-open");
    const closeIcon = document.querySelector(".menu--icon-close");

    if (state === "close") {
      burgerIcon.setAttribute("data-menu-open", "false");
      closeIcon.setAttribute("data-menu-open", "true");
    } else if (state === "burger") {
      burgerIcon.setAttribute("data-menu-open", "true");
      closeIcon.setAttribute("data-menu-open", "false");
    }
  }

  menuClick() {
    const backdrop = document.querySelector(`.lateral-menu--backdrop`);
    const mainDiv = document.querySelector(`#main-menu`);

    const currentState = mainDiv.getAttribute("data-menu-open");

    backdrop.addEventListener("click", (e) => {
      this.handleOutsideClick(e);
    });

    if (currentState == "true") {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  onOptionClick(e) {
    const dataWithChildren = e.target.getAttribute("data-with-children");
    const shouldOpen = dataWithChildren === "false" || dataWithChildren == null;

    if (shouldOpen) {
      return;
    }

    const lvl1Div = document.querySelector(`.lateral-menu--content-inner-lvl1`);
    const mainDiv = document.querySelector(`.lateral-menu--content-inner-lvl2`);
    const insideId = `#${e.target.id}-inside`;
    const toShowDiv = document.querySelector(insideId);

    mainDiv.setAttribute("data-open", true);
    lvl1Div.setAttribute("data-open", false);
    mainDiv.setAttribute("data-target", insideId);
    toShowDiv.setAttribute("data-show", true);
  }

  /** Mobile */
  closeMobile() {
    this.resetMenu();
    this.overflowBody(false);
    const lvl0 = document.querySelector(".lateral-menu--content-inner-lvl0");
    const lvl1 = document.querySelector(".lateral-menu--content-inner-lvl1");
    const mainMenu = document.querySelector("#main-menu");

    lvl1.setAttribute("data-open", "false");
    lvl0.setAttribute("data-show", "true");
    mainMenu.setAttribute("data-menu-open", "false");
  }

  resetLevel1Menu() {
    const lvl0Content = document.querySelector(".lateral-menu--content-inner-lvl0");
    const lvl1Content = document.querySelector(".lateral-menu--content-inner-lvl1");
    lvl0Content.setAttribute("data-show", "true");
    lvl1Content.setAttribute("data-open", "false");
  }

  openLevel1Menu() {
    const lvl0Content = document.querySelector(".lateral-menu--content-inner-lvl0");
    const lvl1Content = document.querySelector(".lateral-menu--content-inner-lvl1");
    lvl0Content.setAttribute("data-show", "false");
    lvl1Content.setAttribute("data-open", "true");
  }
}

customElements.define("scx-lateral-menu", ScxLateralMenu);
